import SuperFetch from '../../superFetch.js';

class brandApi {
  /**
   *  [브랜드] 입점승인 브랜드 리스트 요청하기
   */
  getBrandJoinList = (data) => SuperFetch.post('/store/join/list', data);

  /**
   *  [브랜드] 입점승인 브랜드 excel 리스트 업로드하기
   */
  getBrandJoinExcelDownload = (data) => SuperFetch.post('/store/join/list/excel/download', data);

  /**
   *  [브랜드] 브랜드 리스트 페이지 전체 데이터 요청하기
   */
  getBrandAllInfo = (data) => SuperFetch.post('/store/list/all', data);

  /**
   *  [브랜드] 브랜드 리스트 요청하기
   */
  getBrandList = (data) => SuperFetch.post('/store/list/all/list', data);

  /**
   * [브랜드] 브랜드 태그 검수 리스트 요청하기
   */
  getBrandTagRequestList = (data) => SuperFetch.post('/store/list/tag/request', data);

  /**
   * [브랜드] 브랜드 태그 검수 excel 리스트 다운로드 하기
   */
  getBrandTagRequestDownLoad = (data) => SuperFetch.post('/store/list/tag/request/excel/download', data);

  /**
   *  [브랜드] 입점승인 브랜드 excel 리스트 업로드하기
   */
  getBrandExcelDownload = (data) => SuperFetch.post('/store/list/all/list/excel/download', data);

  /**
   *  [브랜드] 브랜드 상세 정보 요청하기
   */
  getBrandDetail = (data) => SuperFetch.post('/store/detail', data);

  /**
   *  [브랜드] 브랜드 상세 > 브랜드 정보 요청하기
   */
  getBrandDetailInfo = (data) => SuperFetch.post('/store/detail/info', data);

  /**
   *  [브랜드] 브랜드 상세 > 통계 정보 요청하기
   */
  getBrandDetailStatistic = (data) => SuperFetch.post('/store/detail/statistic', data);

  /**
   *  [브랜드] 브랜드 상세 > 정산 정보 요청하기
   */
  getBrandDetailOrderBalance = (data) => SuperFetch.post('/store/detail/order', data);

  /**
   *  [브랜드] 브랜드 상세 > 상품 정보 요청하기
   */
  getBrandDetailProduct = (data) => SuperFetch.post('/store/detail/product', data);

  /**
   *  [브랜드] 브랜드 상세 > 공지사항 정보 요청하기
   */
  getBrandDetailNoticeProduct = (data) => SuperFetch.post('/store/detail/notice/product', data);

  /**
   *  [브랜드] 브랜드 상세 > 상품등록 정보 요청하기
   */
  getBrandDetailProductRegister = (data) => SuperFetch.post('/store/detail/policy', data);

  /**
   *  [브랜드] 브랜드 상세 > 상품 리스트 정보 요청하기
   */
  getBrandDetailProductList = (data) => SuperFetch.post('/store/detail/product', data);

  /**
   *  [브랜드] 브랜드 상세 > 상품 리스트 엑셀 다운로드 요청하기
   */
  getBrandDetailProductExcelDownload = (data) => SuperFetch.post('/store/detail/product/excel/download', data);

  /**
   *  [브랜드] 브랜드 상세 > 공지사항 정보 요청하기
   */
  getBrandDetailNoticeProductList = (data) => SuperFetch.post('/store/detail/notice/product', data);

  /**
   *  [브랜드] 브랜드 상세 > 공지사항 리스트 엑셀 다운로드 요청하기
   */
  getBrandDetailNoticeExcelDownload = (data) => SuperFetch.post('/store/detail/notice/product/excel/download', data);

  /**
   *  [브랜드] 브랜드 입점승인하기
   */
  permitBrand = (data) => SuperFetch.post('/store/detail/permit', data);

  /**
   *  [브랜드] 브랜드 입점승인하기
   */
  rejectBrand = (data) => SuperFetch.post('/store/detail/reject', data);

  /**
   *  [브랜드] 브랜드 수정하기
   */
  editBrand = (data) => SuperFetch.post('/store/detail/info/edit', data);

  /**
   *  [브랜드] 브랜드 상품등록 정보 수정하기
   */
  editBrandProductRegister = (data) => SuperFetch.post('/store/detail/policy/edit', data);

  /**
   *  [브랜드] 브랜드 티어 정보 요청하기
   */
  getBrandTierInfo = (data) => SuperFetch.post('/store/tier/info', data);

  /**
   *  [브랜드] 브랜드 티어 셀렉터 검색하기
   */
  getBrandTierSelectorList = (data) => SuperFetch.post('/store/tier/selector', data);

  /**
   *  [브랜드] 브랜드 티어 수정하기
   */
  editBrandTierList = (data) => SuperFetch.post('/store/tier/edit', data);

  /**
   *  [브랜드] 추천 상품 목록 update
   */
  editRecommendProductList = (data) => SuperFetch.post('/store/recommend/edit', data);

  /**
   *  [브랜드] 노출 브랜드 정보 요청하기
   */
  getBrandExposureInfo = (data) => SuperFetch.post('/store/exposure/list', data);

  /**
   *  [브랜드] 노출 브랜드 셀렉터 요청하기
   */
  getBrandExposureSelectorList = (data) => SuperFetch.post('/store/exposure/selector', data);

  /**
   *  [브랜드] 브랜드 노출 순서 수정하기
   */
  editBrandExposureList = (data) => SuperFetch.post('/store/exposure/edit', data);

  /**
   *  브랜드 태그 승인하기
   */
  permitRegistrationStoreTag = (data) => SuperFetch.post('/store/detail/tag/permit', data);

  /**
   *  브랜드 태그 거절하기
   */
  rejectRegistrationStoreTag = (data) => SuperFetch.post('/store/detail/tag/reject', data);

  /**
   *  [브랜드] 브랜드 태그 리스트 요청하기
   */
  getBrandTagColumnTagList = (data) => SuperFetch.post('/store/list/all/list/tag', data);
}

export default new brandApi();
